module.exports = __webpack_public_path__ + "static/media/secure.f5518f06.jpg";